<template>
	<div class="display-flex flex-column height-100 pb-8">
		<v-expansion-panels v-model="panel" flat accordion>
			<ExpansionPanel v-if="serviceRelatedActions.length === 0" title="Choose app">
				<v-col cols="12" class="app-selection text-left pa-1">
					<div v-if="!selectedApp">
						<h2 class="med">Choose app</h2>
						<v-autocomplete
							ref="searchApp"
							hide-details
							single-line
							:menu-props="menuProps"
							:search-input.sync="searchString"
							:items="appItems"
							item-text="service_name"
							item-value="id"
							color="#5C8DF5"
							height="52px"
							class="ac my-4"
							outlined
							label="Search for an app"
						>
							<template v-slot:prepend-inner>
								<div class="mx-2 s_ic">
									<SIcon name="autocomplete-search" />
								</div>
							</template>
							<template v-slot:append>
								<span></span>
							</template>
						</v-autocomplete>
						<v-row no-gutters v-if="filteredItems.length > 0">
							<v-col
								cols="6"
								role="button"
								v-for="item in filteredItems"
								:key="item.id"
								class="py-5 result_block text-center"
								@click="selectApp(item)"
							>
								<v-row no-gutters class="">
									<v-col class="text-center" cols="12">
										<v-card class="ac_card inline-block ma-0 pa-0">
											<div class="centerdXY">
												<SIcon :width="22" :name="item.service_slug" />
											</div>
										</v-card>
									</v-col>
									<v-col class="text-center" cols="12">
										<h3 class="reg inline-block">{{ item.service_name }}</h3>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</div>
					<div v-else>
						<v-row no-gutters class="choose_item_type">
							<v-col cols="12">
								<v-row no-gutters class="align-center">
									<v-col cols="7" class="text-left">
										<v-row align="center">
											<v-col cols="auto">
												<div class="ac_card inline-block ma-0 pa-0">
													<div class="centerdXY">
														<SIcon :width="16" :name="selectedApp.service_slug" />
													</div>
												</div>
											</v-col>
											<v-col>
												<h3 class="reg inline-block pl-6" style="vertical-align: middle">
													<span>{{ selectedApp.service_name }}</span> <br />
												</h3>
											</v-col>
										</v-row>
									</v-col>
									<v-col class="text-right" cols="5">
										<v-btn rounded outlined color="#D1D9E9" class="chg" height="30px" @click="changeActionOrService">Change</v-btn>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</ExpansionPanel>
			<div class="ml-n1 mt-6 width-100 display-flex flex-row flex-align-center" v-else>
				<ConnectionServiceCard :serviceSlug="selectedApp.service_slug" />
				<div class="servcie-name-text">
					{{ selectedApp.service_name }}
				</div>
			</div>
			<ExpansionPanel v-if="serviceRelatedActions.length > 0" title="Connections">
				<ActionsDetailsMenu class="actions-menu-container" :actions="serviceRelatedActions" />
			</ExpansionPanel>
		</v-expansion-panels>
		<div class="width-100 additional-title-container display-flex flex-column py-4">
			<SettingSwitch
				title="Additional description in title"
				placeholder="Type your description here"
				:switchValue.sync="additionalTitleEnabled"
				:textFieldValue.sync="additionalTitleValue"
			/>
			<div class="description-text">Useful if you have more than one connection block for this app</div>
		</div>
	</div>
</template>

<script>
import AppService from '@/utils/AppService';
import { mapGetters } from 'vuex';
import SettingSwitch from './WidgetSettings/SettingSwitch';
import { getAllServicesList } from '@/store/modules/apps/getters';
import ExpansionPanel from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/ExpansionPanel';
import ActionsDetailsMenu from '@/views/Flow/configurations/SetupMenu/CredentialsSelector/ActionsDetailsMenu.vue';
import ConnectionServiceCard from '@/views/Flow/configurations/SetupMenu/CredentialsSelector/ConnectionServiceCard';
import LocalFieldMixin from './LocalFieldMixin';
export default {
	name: 'CredentialsSelectorFieldSettings',
	// NOTICE: This is the special Field settings component that doesn't use the 'FieldSettingsMixin', because it is significantlly different
	mixins: [LocalFieldMixin],
	components: {
		SettingSwitch,
		ExpansionPanel,
		ActionsDetailsMenu,
		ConnectionServiceCard,
	},
	computed: {
		...mapGetters([getAllServicesList.fullPath, 'widgetEditor/editField', 'apps/getService']),
		serviceRelatedActions() {
			return this.localField.source_of_nodes || [];
		},
		filteredItems() {
			if (this.searchString == '') {
				return this.appItems;
			} else {
				return this.$refs.searchApp.filteredItems;
			}
		},
		menuProps() {
			return { maxHeight: 0 };
		},
		appItems() {
			return [...this[getAllServicesList.fullPath].filter((app) => AppService.doesRequiresAuth(app))];
		},
		selectedApp: {
			get() {
				return this['apps/getService'](this.localField.metadata.source.service);
			},
			set(app) {
				this.setLocalFieldKey('metadata.source.service', app?.id);
				this.setLocalFieldKey('metadata.source.service_version', app?.version);
				this.setLocalFieldKey('metadata.source.service_slug', app?.service_slug);
				this.setLocalFieldKey('metadata.source.service_name', app?.service_name);

				const title = app?.service_name || 'connection';
				this.updateFieldTitle(title);
			},
		},
		stepsToApply: {
			get() {
				return this.localField.metadata.source.nodes || [];
			},
			set(value) {
				this.setLocalFieldKey('metadata.source.nodes', value);
			},
		},
		additionalTitleEnabled: {
			get() {
				return this.localField.metadata.options.additional_title.enabled;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.additional_title.enabled', value);
			},
		},
		additionalTitleValue: {
			get() {
				return this.localField.metadata.options.additional_title.value;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.additional_title.value', value);
			},
		},
	},
	methods: {
		selectApp(app) {
			this.selectedApp = app;
		},
		changeActionOrService() {
			this.selectedApp = null;
			this.stepsToApply = [];
		},
		updateFieldTitle(value) {
			if (!('identifier' in this.localField.metadata.options)) {
				this.fieldIdentifier = this.titleValue;
			}

			const needToUpdateIdentifier = this.fieldIdentifier === this.titleValue;

			this.titleValue = value;
			if (needToUpdateIdentifier) {
				this.fieldIdentifier = value;
			}
		},
	},
	data: () => ({
		panel: 0,
		searchString: '',
	}),
};
</script>
<style scoped lang="scss">
.additional-title-container {
	border-bottom: 1px solid var(--border-color);
	.description-text {
		opacity: 0.5;
		font-size: 12px;
		text-align: center;
		color: var(--primary-font-color);
	}
}
.servcie-name-text {
	font-size: 14px;
	font-weight: 500;
	color: var(--primary-font-color);
}
h3.light {
	color: #6b7786;
	font-weight: 300;
}
.result_block h3 {
	transition: all 0.15s;
}
.result_block:hover h3 {
	color: #61b4f6 !important;
}
.choose_item_type .ac_card {
	width: 40px !important;
	height: 40px !important;
}
.item_type {
	background: white;
	height: 36px;
	width: 100%;
	border: 1px solid #dfe4ef;
	border-radius: 4px;
	line-height: 36px;
	font-size: 14px;
	font-weight: 400 !important;
	text-align: left;
	cursor: pointer;
	transition: all 0.15s;
}
.item_type:hover {
	background: rgba(0, 0, 0, 0.02);
}

h3.med {
	color: #292829;
}
.app-selection ::v-deep(.v-text-field--enclosed .v-input__prepend-inner) {
	margin-top: 9px !important; // hack on top of a hack
}
</style>
